import { ColumnDef } from '@tanstack/react-table'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { ContactsConnectedToCompany } from '../../../../api/inDepthAnalysis/types'

export const useTableColumns = (): ColumnDef<ContactsConnectedToCompany>[] => {
    const { t } = useTranslation()

    return useMemo(
        (): ColumnDef<ContactsConnectedToCompany>[] => [
            {
                header: t('app.common.id'),
                id: 'id',
                enableSorting: false,
                size: 50,
                cell: ({ row }) => <span>{row.original.contactId}</span>,
            },
            {
                header: 'Ime i prezime',
                id: 'name',
                enableSorting: false,
                size: 200,
                cell: ({ row }) => (
                    <span>
                        {row.original.firstName} {row.original.lastName}
                    </span>
                ),
            },
            {
                header: 'Popunjena dubinska analiza',
                id: 'cddFormSubmissionId',
                enableSorting: false,
                size: 200,
                cell: ({ row }) => (row.original.cddFormSubmissionId ? 'DA' : 'NE'),
            },
            {
                header: 'Titula',
                id: 'jobTitle',
                enableSorting: false,
                size: 150,
                accessorKey: 'jobTitle',
            },
            {
                id: 'actions',
                enableSorting: false,
                enableResizing: false,
                size: 60,
                meta: { thDivClass: 'text-center', stopPropagation: true },
                cell: ({ row }) => (
                    <ul className="list-inline hstack gap-2 mb-0 justify-content-center">
                        <li className="list-inline-item edit">
                            <Link
                                title={t('button.edit')}
                                to={`/contacts/${row.original.contactId}`}
                                className="text-info d-inline-block edit-item-btn"
                            >
                                <i className="mdi mdi-pencil-outline fs-16"></i>
                            </Link>
                        </li>
                    </ul>
                ),
            },
        ],
        [t]
    )
}
